import React, { useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  TextField,
  Button,
  Avatar,
  Stack,
  Divider,
  Paper,
  Alert,
} from "@mui/material";
import { LockOutlined, Person } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { userSelector } from "../../Components/user-redux/selector";
import Key from "../../clientVariables.json";
const Profilesettings = () => {
  const { user } = useSelector(userSelector);
  const [activeTab, setActiveTab] = useState(0);
  const [formState, setFormState] = useState({
    fullName: user.full_name || "",
    email: user.username || "",
    mobile: user.phone || "",
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({
    newPassword: false,
    confirmPassword: false,
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Handle Tab Change
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Handle Input Changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Placeholder handlers for form submissions
  const handleUserDetailsSubmit = (event) => {
    event.preventDefault();
    // Implement user details form submission logic here
    alert("User Details Submitted!");
  };

  const handleChangePasswordSubmit = async (event) => {
    event.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = formState;
    // const hashedPassword = await bcrypt.hash(newPassword, 10);
    if (newPassword !== confirmPassword) {
      setError("New passwords do not match.");
      return;
    }
    // if(user?.password !== currentPassword) {
    //     setError('Current password is not match');
    //     return ;
    // }

    const response = await fetch(`${Key.domain}/common/update_password`, {
      // Replace with your actual API endpoint
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: user?.username,
        password: newPassword,
        currentPassword: currentPassword,
      }),
    });

    const result = await response.json();
    if (response.ok && result.success == 1) {
      setSuccess("Password changed successfully!");
      setError("");
      window.location.reload();
    } else if (response.ok && result.success == 0) {
      setError(result.message || "Your Current Password is Incorrect");
    } else {
      setError(result.message || "Failed to change password.");
    }
  };

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", p: 2 }}>
      <Paper elevation={2} style={{ padding: "20px" }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          centered
          sx={{ mb: 3 }}
          variant="fullWidth"
        >
          <Tab label="User Details" icon={<Person />} iconPosition="start" />
          <Tab
            label="Change Password"
            icon={<LockOutlined />}
            iconPosition="start"
          />
        </Tabs>

        {activeTab === 0 && (
          <Box component="form" onSubmit={handleUserDetailsSubmit}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar
                alt="User Profile"
                src="" // You can add a default image or leave it empty
                sx={{ width: 80, height: 80 }}
              />
              <Button variant="outlined" component="label">
                Upload Profile
                <input hidden accept="image/*" type="file" />
              </Button>
            </Stack>

            <Divider sx={{ my: 2 }} />

            <TextField
              label="Full Name"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              name="fullName"
              value={formState.fullName}
              onChange={handleInputChange}
            />
            <TextField
              disabled
              label="Email"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              type="email"
              name="email"
              value={formState.email}
              onChange={handleInputChange}
            />
            <TextField
              label="Mobile"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              type="tel"
              name="mobile"
              value={formState.mobile}
              onChange={handleInputChange}
            />

            <Box sx={{ mt: 2 }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                Save Details
              </Button>
            </Box>
          </Box>
        )}

        {activeTab === 1 && (
          <Box component="form" onSubmit={handleChangePasswordSubmit}>
            {error && <Alert severity="error">{error}</Alert>}
            {success && <Alert severity="success">{success}</Alert>}
            <TextField
              label="Current Password"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              type="password"
              name="currentPassword"
              value={formState.currentPassword}
              onChange={handleInputChange}
            />
            <TextField
              label="New Password"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              type="password"
              name="newPassword"
              value={formState.newPassword}
              onChange={handleInputChange}
            />
            <TextField
              label="Confirm New Password"
              variant="outlined"
              fullWidth
              margin="normal"
              required
              type="password"
              name="confirmPassword"
              value={formState.confirmPassword}
              onChange={handleInputChange}
            />

            <Box sx={{ mt: 2 }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                Change Password
              </Button>
            </Box>
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default Profilesettings;
